import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { ProductRoutingModule } from './product-routing.module';
import { ProductComponent } from './product.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ShareComponent } from './share/share.component';

import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ShareSpeedDialComponent } from './share-speed-dial/share-speed-dial.component';
import { MatMenuModule } from '@angular/material/menu';
import { ImgPreviewComponent } from './img-preview/img-preview.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SareeComponent } from './saree/saree.component';
import { PipesModule } from 'src/app/theme/pipes/pipes.module';
import { ProductLayoutModule } from 'src/app/theme/product-layout/product-layout.module';
import { ControlsModule } from 'src/app/theme/controls/controls.module';
import { TranslateModule } from 'src/app/theme/translate/translate.module';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { AdditionProductComponent } from './addition-product/addition-product.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { ReviewRatingComponent } from './review-rating/review-rating.component';
import { VideoComponent } from './video/video.component';
import { Error404Module } from '../error404/error404.module';
import { BreadcrumbModule } from 'src/app/theme/breadcrumb/breadcrumb.module';
import { ImagezoomModule } from 'src/app/shared/imagezoom/imagezoom.module';
import { MatChipsModule } from '@angular/material/chips';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ProductIconComponent } from './product-icon/product-icon.component';
import { ProductImageComponent } from './product-image/product-image.component';
import { SpecificInfoProductComponent } from './specific-info-product/specific-info-product.component';
import { MedicalAdditionalProductComponent } from './medical-additional-product/medical-additional-product.component';
import { QaProductComponentComponent } from './qa-product-component/qa-product-component.component';
import { AnswerProductComponent } from './answer-product/answer-product.component';
import { SafetyAdviceComponent } from './safety-advice/safety-advice.component';
import { SideEffectsComponent } from './side-effects/side-effects.component';
import { ProductType1Component } from './product-type1/product-type1.component';
import { PriceComponent } from './price/price.component';
import { StarRateComponent } from './star-rate/star-rate.component';
import { ConfigureComponent } from './configure/configure.component';
import { ProductMobileImageComponent } from './product-mobile-image/product-mobile-image.component';
import { ProductType2Component } from './product-type2/product-type2.component';
import { ProductType3Component } from './product-type3/product-type3.component';
import { ProductZoom1Component } from './product-zoom1/product-zoom1.component';
import { ProductType4Component } from './product-type4/product-type4.component';
import { LightboxModule } from 'ngx-lightbox';
import { ProductType5Component } from './product-type5/product-type5.component';
import { ProductImage2Component } from './product-image2/product-image2.component';
import { SizeChartComponent } from './size-chart/size-chart.component';
import { TableModule } from './table/table.module';
import { SizeChartPopupComponent } from './size-chart-popup/size-chart-popup.component';
import { ProductImage3Component } from './product-image3/product-image3.component';
import { ProductType6Component } from './product-type6/product-type6.component';
import { ProductType7Component } from './product-type7/product-type7.component';
import { ProductType8Component } from './product-type8/product-type8.component';
import { ProductType9Component } from './product-type9/product-type9.component';
import { ProductType10Component } from './product-type10/product-type10.component';
import { ProductImage4Component } from './product-image4/product-image4.component';
import { ProductType11Component } from './product-type11/product-type11.component';
import { MessageComponent } from './message/message.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SubscriptionComponent } from './subscription/subscription.component';
import { CustomOptionModule } from '../custom-option/custom-option.module';
@NgModule({
    declarations: [
        ProductComponent,
        ShareComponent,
        ShareSpeedDialComponent,
        ImgPreviewComponent,
        SareeComponent,
        AdditionProductComponent,
        ProductDetailsComponent,
        ReviewRatingComponent,
        VideoComponent,
        ProductIconComponent,
        ProductImageComponent,
        SpecificInfoProductComponent,
        MedicalAdditionalProductComponent,
        QaProductComponentComponent,
        AnswerProductComponent,
        SafetyAdviceComponent,
        SideEffectsComponent,
        ProductType1Component,
        PriceComponent,
        StarRateComponent,
        ConfigureComponent,
        ProductMobileImageComponent,
        ProductType2Component,
        ProductType3Component,
        ProductZoom1Component,
        ProductType4Component,
        ProductType5Component,
        ProductImage2Component,
        SizeChartComponent,
        SizeChartPopupComponent,
        ProductImage3Component,
        ProductType6Component,
        ProductType7Component,
        ProductType8Component,
        ProductType9Component,
        ProductType10Component,
        ProductImage4Component,
        ProductType11Component,
        MessageComponent,
        SubscriptionComponent,
    ],
    imports: [
        CommonModule,
        ProductRoutingModule,
        FlexLayoutModule,
        MatIconModule,
        MatButtonModule,
        MatSnackBarModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule,
        MatCheckboxModule,
        MatTabsModule,
        MatBottomSheetModule,
        MatListModule,
        MatDividerModule,
        MatDialogModule,
        MatInputModule,
        MatCardModule,
        MatRippleModule,
        MatToolbarModule,
        MatMenuModule,
        MatSelectModule,
        MatFormFieldModule,
        ProductLayoutModule,
        ControlsModule,
        TranslateModule,
        BreadcrumbModule,
        ImagezoomModule,
        MatChipsModule,
        CarouselModule,
        MatIconModule,
        LightboxModule,
        TableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        CustomOptionModule

    ],
    providers: [
        DatePipe,
        SocialSharing,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProductModule { }
